<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1>
        <span>品牌</span> x 创意 有趣 x 实用
      </h1>
    </div>
    <div class="anliShare">
      <!-- <el-carousel indicator-position="outside" ref="carousel" v-for="item in index" :key="item.index" :initial-index='item.index'>
        <el-carousel-item v-for="item in imgBox" :key="item.id" name="index">
          <img :src="item.imgSrc" alt @click="openTan"/>
        </el-carousel-item>
      </el-carousel>-->
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/jieshao/baolie-new.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/jieshao/bingxue.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/jieshao/jinshu.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/jieshao/mulan.png" alt />
          </div>

          <div class="swiper-slide">
            <img src="../assets/chanpin/1.png" alt />
          </div>
          <div class="swiper-slide">
            <img src="../assets/chanpin/2New.png" alt />
          </div>
          <!-- <div class="swiper-slide">
            <img
              src="../assets/chanpin/3.png"
              alt
              style="border: 1px solid;box-sizing: border-box;"
            />
          </div> -->
          <div class="swiper-slide">
            <img src="../assets/chanpin/4.png" alt />
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <BottomNav></BottomNav>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Marketing",
  data() {
    return {
      // imgBox: [
      //   {
      //     id: 0,
      //     imgSrc: require("../assets/chanpin-1.jpg")
      //   },
      //   {
      //     id: 1,
      //     imgSrc: require("../assets/chanpin-2.jpg")
      //   }
      // ],
      index: [
        {
          index: 0
        }
      ]
    };
  },

  created() {},
  methods: {
    // setActiveItem(a){
    //   console.log(11)
    //   // var that = this
    //   this.$refs.carousel.setActiveItem(a)
    // }
  },
  mounted() {
    this.index[0].index = this.$route.params.a;
    // setActiveItem(){
    //   this.$refs.carousel.setActiveItem(this.$route.params.a)
    // }
    console.log(this.$route.params.a);

    window.onscroll = function() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;
      } else {
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;
      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
    var swiper = new Swiper(".swiper-container", {
      // loop: true,
      initialSlide: 0,
      // autoplay:true,
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    console.log(this.index[0], ';;;')
    if (this.index[0].index == 0) {
      swiper.slideTo(1);
    }
    if (this.index[0].index == 1) {
      swiper.slideTo(0);
    }
  },
  components: { Nav, BottomNav }
};
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 60px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 4px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.anliShare {
  padding: 100px 0;
  width: 65%;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.swiper-container {
  --swiper-theme-color: #ff6600;
  // --swiper-pagination-color: #00ff33;/* 两种都可以 */
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 40px;
}
.swiper-button-next:after {
  margin-left: 20px;
}
.swiper-button-prev:after {
  margin-right: 20px;
}
.swiper-pagination {
  width: 8%;
  height: 30px;
  padding: 0 31.5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (min-width: 140px) {
    width: 6%;
  }
  @media screen and (min-width: 1520px) {
    width: 5%;
  }
}
.swiper-slide {
  // height: 521px;
  img {
    width: 100%;
  }
}
.swiper-button-prev:after,
.swiper-button-next:after {
  font-size: 30px;
}
.swiper-button-next:after {
  margin-left: 5px;
  color: #fff;
}
.swiper-button-prev:after {
  margin-right: 5px;
  color: #fff;
}
.swiper-button-next {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
.swiper-button-prev {
  width: 50px;
  height: 50px;
  background-color: rgba(31, 45, 61, 0.11);
  border-radius: 50%;
  text-align: center;
  color: #fff;
}
</style>
<style lang="less">
// .el-carousel__container {
//   height: 500px;
// }
:root {
  --swiper-theme-color: rgb(215, 217, 222) !important;
}
.swiper-pagination-bullet {
  background: #999;
}
.el-carousel__button {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
// .el-submenu__title:hover{
//   background-color: #fff !important;
// }
.el-submenu__title {
  color: #333 !important;
}
.el-submenu__title a {
  color: #333 !important;
}
</style>
